import React from 'react';
import css from './SectionInstantBookMaybe.module.css';

/**
 * Compact "Instant Book" pill rendered near the listing title. Tells renters
 * the listing can be booked without waiting for host accept.
 *
 * Shown only when publicData.instantBook === true.
 */
const SectionInstantBookMaybe = props => {
  const { publicData } = props;
  if (publicData?.instantBook !== true) return null;

  return (
    <div className={css.root} role="status">
      <span className={css.pill}>
        <span className={css.bolt} aria-hidden="true">
          <svg width="10" height="12" viewBox="0 0 14 16" fill="none">
            <path d="M8 0L0 9h5l-2 7 8-10H6l2-6z" fill="currentColor" />
          </svg>
        </span>
        <span className={css.label}>Instant Book</span>
        <span className={css.copy}>Confirmed without waiting</span>
      </span>
    </div>
  );
};

export default SectionInstantBookMaybe;
